import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Van2: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m270 225h30v196.17h-30z' />
    <path d='m600 586.17c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m180 586.17c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m220 511.17h340v30h-340z' />
    <path d='m80 360h195v30h-195z' />
    <path d='m270 480v-120s30 0 30 0v90c0 16.57-13.43 30-30 30z' />
    <path d='m720 540h-70v-30h40v-225c0-24.81-20.19-45-45-45h-457.5l-88.5 118c-5.8 7.74-9 17.33-9 27v125h40v30h-70v-155c0-16.12 5.33-32.1 15-45l97.5-130h472.5c41.36 0 75 33.65 75 75z' />
  </IconBase>
));

Van2.displayName = 'Van2';

export default Van2;
